<template>
  <v-flex xs12>
    <v-card>
      <v-toolbar color="primary" dark class="pb-0 mb-0">
        <v-btn icon @click="goBack">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('Conversaciones') }} || Asunto: {{ thread.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="category-select-wrapper">
          <v-select
            class="category-select"
            v-model="thread.category"
            item-text="title"
            item-value="value"
            outline
            :label="$t('Categoría')"
            :items="threadCategories"
            @change="setThreadCategory"
          >
            <template slot="item" slot-scope="data">
              <div
                :class="{
                  'bg-inactive':
                    customerCategories && !customerCategories.includes(data.item.title),
                }"
              >
                {{ data.item.title }}
              </div>
            </template>
          </v-select>
        </div>
        <v-btn
          flat
          :class="{ 'to-manage-active white--text': thread.to_manage }"
          :loading="togglingToManage"
          @click="toggleToManage"
        >
          <v-icon left>{{ thread.to_manage ? 'mdi-flag' : 'mdi-flag-outline' }}</v-icon>
          {{ thread.to_manage ? $t('Quitar «Por gestionar»') : $t('Por gestionar') }}
        </v-btn>
        <v-btn flat v-if="thread.read === 1" @click="readLater">
          {{ $t('Marcar como NO leida') }}
        </v-btn>
        <v-btn flat v-if="thread.read === 0" @click="setAsReadThread">
          {{ $t('Marcar como leída') }}
        </v-btn>
        <v-btn flat v-if="thread.status !== 'pending'" @click="setThreadStatus('pending')">
          {{ $t('Marcar pendiente') }}
        </v-btn>
        <v-btn icon v-if="thread.status !== 'pending'" @click="setThreadStatus('pending')">
          <v-icon>mdi-clock-outline</v-icon>
        </v-btn>
        <v-btn flat v-if="thread.status !== 'closed'" @click="setThreadStatus('closed')">
          {{ $t('Cerrar') }}
        </v-btn>
        <v-btn icon v-if="thread.status !== 'closed'" @click="setThreadStatus('closed')">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
        <v-btn flat v-if="thread.status !== 'active'" @click="setThreadStatus('active')">
          {{ $t('Abrir') }}
        </v-btn>
        <v-btn icon v-if="thread.status !== 'active'" @click="setThreadStatus('active')">
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn v-if="userIsSuperAdmin" color="error" @click="deleteThreadModal = true">
          {{ $t('Eliminar') }}
        </v-btn>
      </v-toolbar>
      <template>
        <v-row justify="center">
          <v-dialog v-model="deleteThreadModal" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                ¿Está seguro de eliminar esta conversación?
              </v-card-title>
              <v-card-text>
                Al realizar esta acción se eliminarán los mensajes y documentos adjuntos.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="deleteThreadModal = false">No, Cancelar</v-btn>
                <v-btn color="error" text @click="deleteThread()">Sí, Eliminar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <template>
        <v-row justify="center">
          <v-dialog v-model="deleteMessageModal" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                ¿Está seguro de eliminar este mensaje?
              </v-card-title>
              <v-card-text>
                Al realizar esta acción se eliminarán los documentos adjuntos en caso de que el
                mensaje contenga alguno.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="deleteMessageModal = false">No, Cancelar</v-btn>
                <v-btn color="error" text @click="onConfirmDeleteMessage()">Sí, Eliminar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <v-progress-linear
        v-if="loading"
        class="py-0 my-0"
        height="3"
        :indeterminate="loading"
      ></v-progress-linear>
      <div class="scroll-y" id="conversation-container" style="max-height: 500px">
        <v-container class="grey lighten-4">
          <template v-if="!loading">
            <template v-for="message in thread.messages">
              <v-layout
                align-center
                :justify-start="message.user_id === thread.user_id"
                :justify-end="thread.consultants.includes(message.user_id)"
                row
                fill-height
                wrap
                :key="message.id"
                my-3
                px-2
              >
                <v-flex xs11>
                  <v-card :class="{ 'consultant-message': messageIsFromAnyConsultant(message) }">
                    <v-card-text contain>
                      <user-avatar
                        :size="40"
                        :user="message.user"
                        :showClavedat="true"
                        :clavedat="thread.company_clavedat"
                      >
                        <span class="mr-3">
                          {{ message.created_at | moment('from', 'now') }}
                        </span>
                        <span class="mr-3">
                          {{ message.created_at | moment('DD/MM/YYYY') }}
                        </span>
                      </user-avatar>
                    </v-card-text>
                    <v-card-text>
                      <v-icon
                        color="primary"
                        v-if="message.attached"
                        @click="downloadEntity(message.attached)"
                      >
                        mdi-download
                      </v-icon>

                      <span
                        v-html="
                          message.message
                            ? message.message.replace(new RegExp('\r?\n', 'g'), '<br />')
                            : message.message
                        "
                        class="message-container"
                      ></span>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-btn
                  v-if="userIsSuperAdmin || messageIsFromConsultant(message)"
                  class="mx-2"
                  fab
                  dark
                  small
                  color="primary"
                  @click="deleteMessage(message.id)"
                >
                  <v-icon dark>mdi-delete</v-icon>
                </v-btn>
              </v-layout>
            </template>
            <div id="conversation-end"></div>
          </template>
        </v-container>
      </div>
      <message-form :thread="thread" advanced @created="newMessage"></message-form>
    </v-card>
  </v-flex>
</template>

<script>
import ThreadAPI from '@/modules/myconsultant/services/thread.js';
import UserAvatar from '@/components/commons/UserAvatar.vue';
import MessageForm from '@/modules/myconsultant/components/threads/MessageForm.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import customer from '@/modules/admin/customers-and-consultants/models/customer';

export default {
  components: {
    UserAvatar,
    MessageForm,
  },
  data() {
    return {
      page: 1,
      thread: {},
      messageIdToDelete: null,
      loading: true,
      scrollTarget: '#conversation-end',
      scrollOptions: {
        duration: 500,
        offset: 0,
        easing: 'easeInOutCubic',
        container: '#conversation-container',
      },
      deleteThreadModal: false,
      deleteMessageModal: false,
      togglingToManage: false,
    };
  },
  created() {
    // this.getThread();
  },
  mounted() {
    this.getThread();
  },
  methods: {
    messageIsFromConsultant(message) {
      if (message && this.user && this.user.id && this.user.id === message.user_id) {
        return true;
      }
      return false;
    },
    messageIsFromAnyConsultant(message) {
      if (
        this.thread &&
        this.thread.consultants &&
        this.thread.consultants &&
        this.thread.consultants.includes(message.user_id)
      ) {
        return true;
      }
      return false;
    },
    downloadEntity(mediaId) {
      console.log(mediaId);

      apiCtrl
        .get('/document/download/' + mediaId)
        .then(res => {
          apiCtrl.downloadFile(res.data);
        })
        .catch(error => {
          console.log(error);
        });
    },

    goToEnd() {
      console.log('scrollTarget', this.scrollTarget, 'scrollOptions', this.scrollOptions);
      this.$vuetify.goTo(this.scrollTarget, this.scrollOptions);
    },

    setThreadStatus(status) {
      ThreadAPI.changeThreadStatus(this.thread.id, status).then(response => {
        this.thread = response.data.data;
        this.loading = false;
      });
      this.thread.status = status;
    },
    toggleToManage() {
      this.togglingToManage = true;
      ThreadAPI.changeThreadToManage(this.thread.id, !this.thread.to_manage)
        .then(response => {
          // Solo cambia la marca: se conserva el resto del thread ya cargado
          this.thread.to_manage = response.data.data.to_manage;
        })
        .catch(() => {})
        .then(() => {
          this.togglingToManage = false;
        });
    },
    setThreadCategory($event) {
      const category = this.threadCategories.find(item => item.value === $event);
      ThreadAPI.changeThreadCategory(this.thread.id, category.value, category.title)
        .then(response => {
          console.log(response);
          this.thread = response.data.data;
        })
        .error(error => {
          console.log(error);
        });
    },
    readLater() {
      console.log('no leida Leida');
      ThreadAPI.changeThreadRead(this.thread.id, 0).then(response => {
        this.thread = response.data.data;
        this.loading = false;
      });
      this.thread.read = 0;
    },
    setAsReadThread() {
      console.log('leído');
      ThreadAPI.changeThreadRead(this.thread.id, 1).then(response => {
        this.thread = response.data.data;
        this.loading = false;
      });
      this.thread.status = 1;
    },
    goBack() {
      this.$router.push({
        path: '/admin/conversations',
      });
    },
    getThread: function() {
      this.loading = true;
      console.log({
        routeparams: this.$route.params,
      });
      ThreadAPI.getThread(this.$route.params.thread).then(response => {
        this.thread = response.data.data;
        this.loading = false;
        const component = this;
        setTimeout(function() {
          component.goToEnd();
        }, 100);

        if (this.thread.read === 0) {
          this.setAsReadThread();
        }
      });
    },
    newMessage: function(message) {
      console.log(message);
      this.thread.messages.push(message);
    },

    deleteThread() {
      apiCtrl
        .delete('/thread/' + this.thread.id)
        .then(res => {
          this.deleteThreadModal = false;
          this.$router.go(-1);
        })
        .catch(error => {
          console.log(error);
          this.deleteThreadModal = false;
        });
    },

    deleteMessage(id) {
      this.messageIdToDelete = id;
      this.deleteMessageModal = true;
    },

    onConfirmDeleteMessage() {
      apiCtrl
        .delete('/message/' + this.messageIdToDelete)
        .then(res => {
          this.getThread();
          this.deleteMessageModal = false;
        })
        .catch(error => {
          console.log(error);
          this.deleteMessageModal = true;
        });
    },
  },
  computed: {
    customer() {
      return customer;
    },
    user() {
      return this.$store.state.user;
    },
    userIsSuperAdmin() {
      const userRoleNames = this.$store.getters.userRoleNames;
      return userRoleNames.includes('superadmin');
    },
    threadCategories() {
      return [
        { title: 'Contable', value: 'contable', icon: 'mdi-cash', color: 'primary' },
        { title: 'Fiscal', value: 'fiscal', icon: 'mdi-script-text-outline', color: 'primary' },
        {
          title: 'Laboral',
          value: 'laboral',
          icon: 'mdi-account-multiple-outline',
          color: 'primary',
        },
        { title: 'Otros', value: 'otros', icon: 'mdi-bookmark-outline', color: 'primary' },
        { title: 'LOPD', value: 'lopd', icon: 'mdi-folder-lock-outline', color: 'primary' },
      ];
    },
    customerCategories() {
      return this.thread ? this.thread.user_categories : [];
    },
  },
};
</script>

<style>
.message-container img {
  max-width: 100% !important;
}

.category-select-wrapper {
  max-width: 200px;
  padding: 0 15px;
  background-color: white;
}

.category-select {
  .v-input__slot {
    margin-bottom: 0 !important;
    border: 0 !important;
  }
  .v-icon {
    color: black !important;
  }
  .v-select__selections {
    color: black !important;
  }
  .v-label {
    color: #52d99f !important;
  }
}

.to-manage-active {
  background-color: #673ab7 !important;
}

.bg-inactive {
  background-color: pink;
  padding: 0 15px;
}
</style>
